<template>
  <v-slide-y-transition mode="out-in">
    <v-container class="fill-height pa-0 mt-0 chat-drawer-container fluid">      
      <template v-if="!$vuetify.breakpoint.smAndDown">
        <v-layout row>
          <v-flex lg3 class="chat-contact--sidebar white">
            <list-kompetisi></list-kompetisi>
          </v-flex>
          <v-flex lg3 v-if="showDapil">
            <list-dapil style="border:0px 1px solid #eee"></list-dapil>
          </v-flex>
          <v-flex lg3 v-if="showPartaiLeg">
            <list-partai></list-partai>
          </v-flex>
          <v-flex lg3 v-if="showCalonLeg">
            <list-partai-calon></list-partai-calon>
          </v-flex>
          <v-flex lg9 v-if="showCalonEks">
            <list-calon></list-calon>
          </v-flex>          
          <v-flex lg6 v-if="showCalonDpd">
            <list-calon></list-calon>
          </v-flex>          
        </v-layout>
      </template>
      <template v-else>
        <v-layout column>
          <v-flex lg12 v-if="showCalonDpd">
            <list-calon></list-calon>
          </v-flex>
          <v-flex lg12 v-else-if="showCalonEks">
            <list-calon></list-calon>
          </v-flex>  
           <v-flex lg12 v-else-if="showCalonLeg">
            <list-partai-calon></list-partai-calon>
          </v-flex>
          <v-flex lg12 v-else-if="showPartaiLeg">
            <list-partai></list-partai>
          </v-flex>
          <v-flex lg12 v-else-if="showDapil">
            <list-dapil style="border:0px 1px solid #eee"></list-dapil>
          </v-flex>
          <v-flex lg12 v-else-if="showWindow" class="chat-contact--sidebar white">
            <list-kompetisi></list-kompetisi>
          </v-flex>
        </v-layout>        
      </template>
    </v-container>
  </v-slide-y-transition>  
</template>
<script>
import ListKompetisi    from './list-kompetisi';
import ListDapil        from './list-dapil';
import ListPartai       from './list-partai';
import ListPartaiCalon  from './list-partai-calon';
import ListCalon        from './list-calon';
import PartaiView       from './view';

var _  = require('lodash');

export default {
  components: {
    ListKompetisi,
    ListDapil,
    ListPartai,
    ListPartaiCalon,
    ListCalon,    
    PartaiView
  },
  data () {
    return {
      //chat: null,
      //selectedTab: null,
    };
  },
  computed: {
    
    showWindow () {
      return this.$route.query.kompetisi_id === undefined;
    },    
    showDapil() {
      return this.$route.query.kompetisi_id !== undefined && this.$route.query.mode >= 2;
    },
    showCalonEks() {
      return this.$route.query.mode == 1;
    },
    showPartaiLeg() {
      return this.$route.query.mode == 2 && this.$route.query.dapil_id !== undefined;
    },
    showCalonLeg() {
      return this.showPartaiLeg && this.$route.query.id !== undefined;
    },
    showCalonDpd() {
      return this.$route.query.mode == 3 && this.$route.query.dapil_id !== undefined;;
    },
  },
};
</script>

